export default __webpack_public_path__ + "locales/ro/PreparationPortal.json?hash=8cff6a3020301137fa1b39e44745c954";